module.exports = __webpack_public_path__ + "static/media/new-mail.2e363cf0.svg";